var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.5,
    height: 24.75,
    viewBox: "0 0 31.5 24.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "camera",
    transform: "translate(-2.249 -5.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M22.5,19.125a4.5,4.5,0,1,1-4.5-4.5A4.5,4.5,0,0,1,22.5,19.125Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M30.375,10.125H26.227a1.023,1.023,0,0,1-.676-.352L23.727,6.894a1.091,1.091,0,0,0-.1-.13,3.139,3.139,0,0,0-2.4-1.139H14.765a3.133,3.133,0,0,0-2.4,1.14,1.091,1.091,0,0,0-.1.13L10.449,9.778a.921.921,0,0,1-.606.352V9.567A1.125,1.125,0,0,0,8.718,8.442H7.03A1.125,1.125,0,0,0,5.9,9.567v.563H5.624a3.379,3.379,0,0,0-3.375,3.375V27a3.379,3.379,0,0,0,3.375,3.375h24.75A3.379,3.379,0,0,0,33.749,27V13.5a3.379,3.379,0,0,0-3.375-3.375ZM18,25.875a6.75,6.75,0,1,1,6.75-6.75A6.75,6.75,0,0,1,18,25.875Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.9bd45213f82a18fbb2a5fe74fb50cc68.svg";
export { ForwardRef as ReactComponent };